export default __webpack_public_path__ + "img/bb6b5c565749dddfc13f98d8e30c40cf.png";